
import './styles/quasar.sass'
import lang from 'quasar/lang/es.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/mdi-v4/mdi-v4.css'
import Quasar from 'quasar/src/vue-plugin.js';import Loading from 'quasar/src/plugins/loading/Loading.js';import Notify from 'quasar/src/plugins/notify/Notify.js';import Dialog from 'quasar/src/plugins/dialog/Dialog.js';import Dark from 'quasar/src/plugins/dark/Dark.js';

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {
    Loading, Notify, Dialog
  },
  lang: lang
}